import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState, useRef } from 'react';
import { ImageCrop } from '../../../../ImageCrop';
import { useRefCallback, useRefFunction } from '@tencent/glue-react-use';
import { Modal } from '../../../../Modal';
import { LibraryUploadStep } from '../../../context/MaterialPanelContext';
import { getHumanSizeStr, getValidCropSize, noop, validateImage } from '../../common/utils';
import { UploadFileType, UploadStatus } from '../type/interface';
import { API_TIMEOUT_ERROR_MSG, COMPRESSED_IMAGE_SIZE_EXCEED, IMAGE_ACCEPT_TYPES, IMAGE_MAX_SIZE_LIMIT, SERVER_AUTH_ERROR_MSG, SERVER_ERROR_MSG } from '../../common/const';
import { useRcMaterialPanel } from '../../MaterialPanel/RcMaterialPanel/RcMaterialPanel';
import { selectImageFile, transImageUploadValue } from '../util/util';
import { getLocalFileRequestData, getUrlFileRequestData, imageUploadRequest } from '../util/imageUploadRequest';
export var getImageNaturalCroppedArea = function getImageNaturalCroppedArea(opt) {
  var width = opt.width,
    height = opt.height;
  return {
    croppedAreaPixels: {
      x: 0,
      y: 0,
      height: height,
      width: width
    },
    targetSize: {
      width: width,
      height: height
    }
  };
};
export var useImageUpload = function useImageUpload(props) {
  var cropSizeConfig = props.cropSizeConfig,
    panelStyleConfig = props.panelStyleConfig,
    value = props.value,
    _props$uploadConfig = props.uploadConfig,
    request = _props$uploadConfig.request,
    uid = _props$uploadConfig.uid,
    localUpload = _props$uploadConfig.localUpload,
    urlUpload = _props$uploadConfig.urlUpload,
    onCancel = props.onCancel,
    onOk = props.onOk,
    onValueChange = props.onValueChange;
  var _useRcMaterialPanel = useRcMaterialPanel(),
    step = _useRcMaterialPanel.step,
    setErrMsg = _useRcMaterialPanel.setErrMsg,
    setStep = _useRcMaterialPanel.setStep,
    setCurrentUploadDetail = _useRcMaterialPanel.setCurrentUploadDetail;
  var croppedAreaRef = useRef();
  var _useState = useState(cropSizeConfig || []),
    _useState2 = _slicedToArray(_useState, 2),
    validCropSizeConf = _useState2[0],
    setValidCropSize = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    uploadImageFileInfo = _useState4[0],
    setUploadImageFileInfo = _useState4[1];
  var onCropComplete = useRefCallback(function (croppedAreaPixels, targetSize) {
    croppedAreaRef.current = {
      croppedAreaPixels: croppedAreaPixels,
      targetSize: targetSize
    };
  });
  var beforeCrop = useRefFunction(function (uploadType, imageInfo) {
    var fileUrl = imageInfo.url,
      width = imageInfo.width,
      height = imageInfo.height,
      size = imageInfo.size,
      name = imageInfo.name;
    var limit = localUpload.sizeLimit || IMAGE_MAX_SIZE_LIMIT;
    setCurrentUploadDetail({
      poster: fileUrl,
      abort: noop,
      fileName: name
    });
    if (uploadType === UploadFileType.LOCAL && size > limit) {
      setErrMsg("\u56FE\u7247\u4E0D\u5F97\u8D85\u8FC7".concat(getHumanSizeStr(limit, 0), "\uFF0C\u8BF7\u8C03\u6574\u540E\u91CD\u65B0\u4E0A\u4F20"));
      setStep(LibraryUploadStep.FAIL);
      return false;
    }
    if (!cropSizeConfig) {
      return 'SKIP_CROP';
    }
    var result = validateImage({
      cropSizeConfig: cropSizeConfig,
      size: {
        width: width,
        height: height
      }
    });
    if (result === false) {
      setErrMsg('上传图片比规定尺寸小，请重新上传');
      setStep(LibraryUploadStep.FAIL);
    } else if (result === true) {
      var validCropSize = getValidCropSize({
        config: cropSizeConfig,
        size: {
          width: width,
          height: height
        }
      });
      setValidCropSize(validCropSize);
      setStep(LibraryUploadStep.IMAGE_URL_CROP);
    }
    return result;
  });
  var onChange = function onChange(changeVal, imageInfo) {
    var index = changeVal.index;
    switch (changeVal.status) {
      case UploadStatus.UPLOADING:
        {
          setStep(LibraryUploadStep.UPLOADING);
          var fileName = imageInfo.name,
            fileUrl = imageInfo.url;
          setCurrentUploadDetail({
            fileName: fileName,
            poster: fileUrl,
            abort: changeVal.abort
          });
          break;
        }
      case UploadStatus.SUCCESS:
        {
          setStep(LibraryUploadStep.SUCCESS);
          var _changeVal$response = changeVal.response,
            code = _changeVal$response.code,
            data = _changeVal$response.data,
            message = _changeVal$response.message;
          if (code === 0 && data.mp_image_url) {
            var nextValue = _toConsumableArray(value);
            nextValue[index] = transImageUploadValue(data);
            onValueChange(_toConsumableArray(nextValue));
            return;
          }
          var errMsg = SERVER_ERROR_MSG;
          if (code === 2 && typeof message === 'string' && message === 'Failed to execute all of these operations') {
            errMsg = COMPRESSED_IMAGE_SIZE_EXCEED;
          } else if (code === 401) {
            errMsg = SERVER_AUTH_ERROR_MSG;
          } else if (code === 408) {
            errMsg = API_TIMEOUT_ERROR_MSG;
          }
          setErrMsg(errMsg);
          setStep(LibraryUploadStep.FAIL);
          break;
        }
      case UploadStatus.ERROR:
        {
          setStep(LibraryUploadStep.FAIL);
          setErrMsg(SERVER_ERROR_MSG);
        }
    }
  };
  var uploadProc = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(opt) {
      var url, uploadType, imageInfo, requestData, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = opt.url, uploadType = opt.uploadType, imageInfo = opt.imageInfo, requestData = opt.requestData;
              _context.next = 3;
              return beforeCrop(uploadType, imageInfo);
            case 3:
              result = _context.sent;
              _context.t0 = result;
              _context.next = _context.t0 === 'SKIP_CROP' ? 7 : _context.t0 === true ? 10 : 11;
              break;
            case 7:
              _context.next = 9;
              return imageUploadRequest({
                url: url,
                request: request,
                requestData: requestData,
                onChange: onChange,
                imageInfo: imageInfo
              });
            case 9:
              return _context.abrupt("break", 11);
            case 10:
              setStep(LibraryUploadStep.IMAGE_URL_CROP);
            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function uploadProc(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var uploadLocalFile = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(index) {
      var url, _localUpload$accept, accept, _localUpload$sizeLimi, sizeLimit, fileDetail, size, width, height, uploadFileInfo, croppedArea, formData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              url = localUpload.url;
              _localUpload$accept = localUpload.accept, accept = _localUpload$accept === void 0 ? IMAGE_ACCEPT_TYPES : _localUpload$accept, _localUpload$sizeLimi = localUpload.sizeLimit, sizeLimit = _localUpload$sizeLimi === void 0 ? IMAGE_MAX_SIZE_LIMIT : _localUpload$sizeLimi;
              _context2.next = 4;
              return selectImageFile({
                accept: accept
              });
            case 4:
              fileDetail = _context2.sent;
              size = fileDetail.size, width = fileDetail.width, height = fileDetail.height;
              uploadFileInfo = _objectSpread({
                type: 'file',
                index: index
              }, fileDetail);
              setUploadImageFileInfo(uploadFileInfo);
              if (!(size > sizeLimit)) {
                _context2.next = 12;
                break;
              }
              setErrMsg("\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7".concat(getHumanSizeStr(sizeLimit, 0)));
              setStep(LibraryUploadStep.FAIL);
              return _context2.abrupt("return");
            case 12:
              croppedArea = getImageNaturalCroppedArea({
                width: width,
                height: height
              });
              formData = getLocalFileRequestData({
                croppedArea: croppedArea,
                uid: uid,
                imageInfo: uploadFileInfo
              });
              return _context2.abrupt("return", uploadProc({
                url: url,
                uploadType: UploadFileType.LOCAL,
                imageInfo: uploadFileInfo,
                requestData: formData
              }));
            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function uploadLocalFile(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var uploadUrlFile = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(opt) {
      var urlFile, fileType, width, height, name, index, url, fileInfo, croppedArea, requestData;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              urlFile = opt.urlFile, fileType = opt.fileType, width = opt.width, height = opt.height, name = opt.name, index = opt.index;
              url = urlUpload.url;
              fileInfo = {
                urlFile: urlFile,
                type: 'url',
                url: urlFile,
                fileType: fileType,
                width: width,
                height: height,
                name: name,
                size: 0,
                index: index
              };
              setUploadImageFileInfo(fileInfo);
              croppedArea = getImageNaturalCroppedArea({
                width: width,
                height: height
              });
              requestData = getUrlFileRequestData({
                croppedArea: croppedArea,
                uid: uid,
                imageInfo: fileInfo
              });
              return _context3.abrupt("return", uploadProc({
                url: url,
                uploadType: UploadFileType.URL,
                imageInfo: fileInfo,
                requestData: requestData
              }));
            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function uploadUrlFile(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  var okHandle = useRefCallback(function () {
    if (!uploadImageFileInfo) {
      throw new Error('uploadImageFileInfo is null!');
    }
    if (!croppedAreaRef.current) {
      throw new Error('croppedAreaRef.current is null');
    }
    var url;
    var requestData;
    if (uploadImageFileInfo.type === 'file') {
      url = localUpload.url;
      requestData = getLocalFileRequestData({
        croppedArea: croppedAreaRef.current,
        uid: uid,
        imageInfo: uploadImageFileInfo
      });
    } else {
      url = urlUpload.url;
      requestData = getUrlFileRequestData({
        croppedArea: croppedAreaRef.current,
        uid: uid,
        imageInfo: uploadImageFileInfo
      });
    }
    imageUploadRequest({
      url: url,
      request: request,
      requestData: requestData,
      onChange: onChange,
      imageInfo: uploadImageFileInfo
    });
    onOk === null || onOk === void 0 ? void 0 : onOk();
  });
  var onCancelHandle = useRefCallback(onCancel);
  var cropNode = uploadImageFileInfo && React.createElement(Modal, {
    show: step === LibraryUploadStep.IMAGE_URL_CROP,
    onCancel: onCancelHandle,
    onOk: okHandle,
    bodyStyle: {
      width: (panelStyleConfig === null || panelStyleConfig === void 0 ? void 0 : panelStyleConfig.panelWidth) || 900
    },
    hideToDestroy: true,
    title: "\u56FE\u7247\u88C1\u526A"
  }, React.createElement("div", {
    style: {
      minHeight: (panelStyleConfig === null || panelStyleConfig === void 0 ? void 0 : panelStyleConfig.panelHeight) || 514
    }
  }, React.createElement(ImageCrop, {
    image: {
      url: uploadImageFileInfo.url,
      name: uploadImageFileInfo.name,
      width: uploadImageFileInfo.width,
      height: uploadImageFileInfo.height
    },
    cropSizeConfig: validCropSizeConf,
    onCropComplete: onCropComplete,
    panelStyleConfig: panelStyleConfig
  })));
  return {
    uploadUrlFile: uploadUrlFile,
    uploadLocalFile: uploadLocalFile,
    cropNode: cropNode
  };
};